<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      isKeydown: false,
    }
  },
  computed: {
    ...mapGetters({
      subIndex: "subtitle/subIndex",
      subtitles: "subtitle/subtitles",
      isPreventDefault: "subtitle/isPreventDefault",
      musicIndex: "addSoundtrack/getMusicIndex",
      selectMusic: "addSoundtrack/getSelectMusic",
      dubbingIndex: "addSoundtrack/getDubbingIndex",
      selectDubbing: "addSoundtrack/getSelectDubbing",
      shortcutType: 'shortcutType'
    }),
  },
  mounted () {
    document.addEventListener("keydown", this.keydown, false)
    document.addEventListener("keyup", this.keyup, false);
  },
  beforeDestroy(){
    document.removeEventListener("keydown", this.keydown);
    document.removeEventListener("keyup", this.keyup);
  },
  methods: {
    keydown(e) {
      if (this.shortcutType !== 'subtitle') return;
      if (!this.isPreventDefault || this.isKeydown) return;
      e = e || window.event;
      let keyCode = e.keyCode || e.which || e.charCode;
      let ctrlKey = e.ctrlKey,
          metaKey = e.metaKey,
          shiftKey = e.shiftKey;
      // 阻止一直按键导致快捷键连续触发（撤销部分会出现问题--->没有根本解决）
      // if(ctrlKey || metaKey || shiftKey) {
      if(keyCode === 17 || keyCode === 16 || keyCode === 91 || keyCode === 93) {
        this.isKeydown = false;
      }else {
        this.isKeydown = true;
      }

      if ((ctrlKey || metaKey) && !shiftKey) {
        // ctrl || meta
        if (keyCode === 90) {
          // ctrl + z：撤销
          this.$bus.emit('subtitle_keycode_undo', {type: 'undo'});
          this.preventDefaultF(e)
        } else if (keyCode === 89) {
          // ctrl + y：返回
          this.$bus.emit('subtitle_keycode_undo', {type: 'redo'});
          this.preventDefaultF(e)
        } else if(keyCode === 83) {
          // ctrl + s: 保存
          // to do
          this.preventDefaultF(e)
        }
      } else if (shiftKey && !ctrlKey && !metaKey) {
        // shift
      } else if (!ctrlKey && !metaKey && !shiftKey) {
         if (keyCode === 37) {
          // Left Arrow: 向左移动1px
          this.move(-1, 0);
          this.preventDefaultF(e)
        } else if (keyCode === 38) {
          // Up Arrow: 向上移动1px
          this.move(0, -1);
          this.preventDefaultF(e)
        } else if (keyCode === 39) {
          // Right Arrow: 向右移动1px
          this.move(1, 0);
          this.preventDefaultF(e)
        } else if (keyCode === 40) {
          // Down Arrow: 向下移动1px
          this.move(0, 1);
          this.preventDefaultF(e)
        } else if (keyCode === 46 || keyCode === 8) {
          // delete: 删除
          this.delSubtitle()
          this.preventDefaultF(e)
        } else if( keyCode === 32) {
          this.$bus.emit('subtitle_keycode_space');
          this.preventDefaultF(e)
        }
      }
    },
    keyup(e) {
      this.isKeydown = false;
    },
    preventDefaultF(e) {
      if (this.isPreventDefault) {
        e.preventDefault();
        return false;
      }
    },
    move(x, y) {
      // 移动 --- to do
    },
    delSubtitle() {
      if (this.subIndex > -1) {
        this.$bus.emit("insert_subtitle_undo", {
          type: "delSubtitles",
          data: {
            index: this.subIndex,
            data: JSON.stringify(this.subtitles[this.subIndex])
          }
        });
        this.$store.commit("subtitle/delSubtitles");

        this.$bus.emit('subtitle_keycode_del');
        this.$store.commit("addSoundtrack/setSoundtrackState", {type: 'noSet'});
      }
      if (this.dubbingIndex > -1) {
        this.$bus.emit("insert_subtitle_undo", {
          type: "delDubbing",
          data: {
            index: this.dubbingIndex,
            data: JSON.stringify(Object.assign({}, this.selectDubbing, { load: false, ele: null, playing: false }))
          }
        });
        this.$store.commit("addSoundtrack/delDubbing", this.dubbingIndex);
        this.$store.commit("addSoundtrack/setSoundtrackState", {type: 'noSet'});
      }
      if(this.musicIndex > -1) {
        let loopStatus = this.$store.getters['addSoundtrack/getPlayHandle'].musicLoop ? 'loop': 'unloop';
        this.$bus.emit("insert_subtitle_undo", {
          type: "delMusic",
          data: {
            loopStatus,
            index: this.musicIndex,
            data: JSON.stringify(
              Object.assign({}, this.selectMusic, {
                load: false,
                ele: null,
                playing: false,
              })
            )
          }
        });
        this.$store.commit("addSoundtrack/delMusic", this.musicIndex);
        this.$store.commit("addSoundtrack/setSoundtrackState", {type: 'noSet'});
        if (loopStatus === 'loop') {
          this.$store.commit("addSoundtrack/setLoopSoundtrackStatus", false);
        }
      }
    }
  },
  beforeDestroy(){
  }
}
</script>



// WEBPACK FOOTER //
// src/components/subtitle/keyboard.vue